import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=2d3e69b2"
import script from "./InvoiceDetails.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetails.vue?vue&type=script&lang=ts"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=2d3e69b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports